<template>
  <div id = "carInsurenceWidget-container">
    <label class="block-caption" :style="{ color: widgetSettingsData.inputLabelColor, background: widgetSettingsData.inputLabelBackgroundColor, width: '100%', display:'block'}">Indtast bilens nummerplade 
    </label>
    <div class = "caption-container">
      <div class="text-input-container">
        <img src="../assets/dk.png" class = "carInsurenceWidget-DK">
        <input 
        v-bind:class="{ 'inputError': hasError, 'noErrors':noErrors}"
        type = "text" 
        placeholder="AB12121"
        maxlength="7"
        v-model="vechicalID"
        @change="validateInput"
        :style="{'border-color':widgetSettingsData.inputfieldBorderColor, 
      background:widgetSettingsData.inputfieldBackgroundColor}" 
        > 
        <div class = "carInsurenceWidget-button"
          @click="followUrl"
          @linkClicked="followSamlinoLink"
          :style = "{ color: widgetSettingsData.summarybuttonTextColor, background:widgetSettingsData.summarybuttonColor}"
        >
        {{buttontext}}
        </div><!-- carInsurenceWidget-button -->
      </div><!-- text-input-container" -->
    </div>
      <p :class="{ 'adressError':hasError, 'adressOk':noErrors}" >Input skal bestå af 2 bogstaver og 5 tal</p>

        <p class="dontKnowCarLicNumber-link" @click="followSamlinoLink">Jeg kender ikke nummerpladen </p>
  </div><!-- carInsurenceWidget-container -->
</template>




<script>
// Declaration part
let utmparams = "";
let followUrl = "";

//Getting url with params:
let addressString = window.location.href;

export default {
  name: 'locarInsurenceWidget',
  data(){
    return{
    widgetSettingsData:{
      widgetheading:"test caption",
      inputLabelText:"label text",
      sliderColor:"red",
      headingon:true,
    }//widgetSettingsData
    ,
    buttontext:"button",
    noErrors:true,
    hasError:false
    }
  },
  created() {
  window.addEventListener('message', this.receiveDatafromIframe);

  if(window.frameElement !== null && window.frameElement.getAttribute('data-headingStyleOptions') !== null){
    let iframeConfigData = JSON.parse( window.frameElement.getAttribute('data-headingStyleOptions') );
    this.widgetSettingsData = iframeConfigData;
  }

  this.$nextTick(function() {
    window.addEventListener('storage', this.applySettingsFromLocalStorage);
  })//nextTick
},//created
methods: {
  receiveDatafromIframe(event){
  if(event.data.loaded ==="yes"){
    this.widgetSettingsData = event.data;
    document.body.style.setProperty('--slidercolor', this.widgetSettingsData.sliderColor);
    this.buttontext = this.widgetSettingsData.summarybuttonText;
    this.widgetSettingsData.headingTextColor=event.data.headingTextColor;
    if(event.data.headingon === "false"){
    this.widgetSettingsData.headingon = false;
    }
  }
},
  applySettingsFromLocalStorage(){ 
    if(window.localStorage.getItem("headingtext") !== null){
      this.widgetSettingsData = JSON.parse(window.localStorage.getItem("headingtext") );
      document.body.style.setProperty('--slidercolor', this.widgetSettingsData.sliderColor);
      this.buttontext = this.widgetSettingsData.summarybuttonText;
      }
    },//applySettingsFromLocalStorage
followUrl:function(){
//this.validateInput();
if(typeof(this.vechicalID) !== "undefined" && this.vechicalID.length >= 7){
  this.hasError = false;
this.noErrors = true;

 //checking if there any params in url
    if(addressString.indexOf('#') > 0 
      || addressString.indexOf('utm_source') > 0 
      || addressString.indexOf('utm_medium') > 0 
      || addressString.indexOf('utm_campaign') > 0
    ){

      followUrl = "https://www.samlino.dk/bilforsikring/indhentpriser?" + "licensePlateNumUq=" + this.vechicalID + "&" + "knowLicensePlateNum=true" + "&" + utmparams ;
      }
    else{
      followUrl = "https://www.samlino.dk/bilforsikring/indhentpriser?" + "licensePlateNumUq=" + this.vechicalID + "&" + "knowLicensePlateNum=true" 
    }
  window.open(followUrl, '_blank');
}else{
this.hasError = true;
this.noErrors = false;
}
    },
prepareUrlParams:function(){
var source = "";
var medium = "";
var campaign = "";
 
            if(this.widgetSettingsData.source == "" || typeof(this.widgetSettingsData.source) === "undefined"){
              source = "iframe";
            }else{
              source = this.widgetSettingsData.source;
            }

            if(this.widgetSettingsData.medium == "" || typeof(this.widgetSettingsData.medium) === "undefined"){
              medium = "referral"
            }else{
              medium = this.widgetSettingsData.medium;
            }

            if( this.widgetSettingsData.campaign == "" || typeof(this.widgetSettingsData.campaign) === "undefined"){
              campaign = "default";
            }else{
              campaign = this.widgetSettingsData.campaign;
            }
            
            utmparams = "utm_source=" + source + "&"
            + "utm_medium=" + medium + "&"
            + "utm_campaign=" + campaign;

    return utmparams;
},
followSamlinoLink:function(){
  this.prepareUrlParams();
let followSamlinoLink = "https://www.samlino.dk/bilforsikring/indhentpriser?knowLicensePlateNum=false" + "&" + utmparams;
window.open(followSamlinoLink, '_blank');
},
validateInput:function(){
  let re = /^[a-zA-Z][a-zA-Z][0-9][0-9][0-9][0-9][0-9]/g;
  if( this.vechicalID === ""){
this.hasError = false;
this.noErrors = false;
  } else if(this.vechicalID.length <= 6 || !re.test(this.vechicalID)){
this.hasError = true;
this.noErrors = false;
  }else{
    this.hasError = false;
    this.noErrors = true;
      }
    }

  }
}

</script>


<style>

.noErrors{
  border-color:green !important;
}

.inputError{
  border-color:red !important;
}

.adressError{
  display: block;
  color:red;
  font-weight: bold;
  text-align: left;
}

.adressOk{
  display:none;
  text-align: left;
}

#carInsurenceWidget-container{
  width:96%;
  margin-left:2%;
  margin-right:2%;
  background: white;
}

.block-caption{
  display: block;
  font-weight:bold;
  padding-top:5px;
  padding-bottom:7px;
}

.text-input-container{
  display: flex;
  margin:0;
  padding:0;
  width:100%;
  height:56px;
}

.carInsurenceWidget-DK{
display: block;
  float:left;
  padding:0;
  margin:0;
  height: 100%;
  width:auto;
  background: green;
  border:none;
  border-radius: 3px 0px 0px 3px;
  border-right-style:none;
}

.dontKnowCarLicNumber-link{
display: block;
padding-top:10px;
padding-bottom:5px;
color: #519BC6;
text-decoration: underline;
}

.dontKnowCarLicNumber-link:hover{
	cursor: pointer;
	}

input[type=text]{
  display: flex;
  float:left;
  padding:0;
  margin:0;
  border-style:none;
  width: 75.0%;
  height:54px;
    line-height: 24px;
      border-width:1px;
      border-style:solid;
      border-radius: 0px 3px 3px 0px;
      border-color:grey;
        font-size: 16px;
        line-height: 24px;
        color:rgb(49, 47, 43);
        padding-left:10px;
}

.carInsurenceWidget-button{
  display: flex;
  padding:0;
  margin:0;
  width: 19.0%;
  color:white;
  background: #f58423;
    border:none;
    border-radius:3px;
    text-align:center;
    padding-top:15px ;
    justify-content: center;
    margin-left:1.4%;
    font-family:proxima-nova, "Helvetica Neue", Helvetica, "Microsoft JhengHei", "Open Sans", Arial, sans-serif;
    font-size: 16px;
    font-weight:900;
    line-height: 24px;
    box-shadow: 0 1px 8px 0 rgb(0 0 0 / 15%);
}


#carInsurenceWidget-container a{
  display: block;
  padding-top:10px;
  padding-bottom:5px;
}


@media screen and (max-width: 380px) /* Mobile */ {
.carInsurenceWidget-button{
  font-size:12px;
}

  }/* @media screen and (max-width: 350px) */


@media screen and (max-width: 320px) /* Mobile */ {
.carInsurenceWidget-button{
  font-size:9px;
}


  }/* @media screen and (max-width: 270px) */
</style>
